export default __webpack_public_path__ + "static/media/auth-card.0aa9408d.png";